import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ExternalLinksHandler.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
